const fTitle = document.querySelector('meta[name="fundraiser-title"]').getAttribute('content')
const heading = document.createElement('h2')
heading.className = 'h4 text-center'
heading.textContent = fTitle
const header = document.querySelector('.widget-header')
header.insertBefore(heading, header.firstChild)
